import { useMutation } from '@apollo/client'
import { DenyVaccination, DenyVaccinationVariables } from '../../types'
import { DENY_VACCINATION } from './operations'

export const useDenyVaccination = () =>
  useMutation<DenyVaccination, DenyVaccinationVariables>(DENY_VACCINATION)
